/* BOLD Daylight UX: cart drawer + AJAX add + predictive search + header + PDP gallery + sticky ATC */
(function () {
  'use strict';
  var routes = window.dlRoutes || {};
  var moneyFormat = window.dlMoneyFormat || 'Dhs. {{amount}}';

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* ---------------- cart drawer ---------------- */
  var root = document.getElementById('dl-cart-root');
  var closeTimer = null;
  var lastFocus = null;
  var drawer = {
    el: root,
    open: function () {
      if (!root) { window.location.href = routes.cart_url || '/cart'; return; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      lastFocus = document.activeElement;
      root.querySelector('.dlcd-overlay').hidden = false;
      root.querySelector('.dlcd').hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.classList.add('dlcd-lock');
      var x = root.querySelector('.dlcd-x');
      if (x) setTimeout(function () { x.focus(); }, 60);
    },
    close: function () {
      if (!root) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('dlcd-lock');
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        var ov = root.querySelector('.dlcd-overlay'), dr = root.querySelector('.dlcd');
        if (ov) ov.hidden = true; if (dr) dr.hidden = true;
        closeTimer = null;
      }, 250);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
    },
    refresh: function (openAfter) {
      /* a failed refresh must never read as a failed add: fall back to the badge only */
      return fetch(window.location.pathname + '?sections=dl-cart-drawer')
        .then(function (r) { if (!r.ok) throw new Error('section render ' + r.status); return r.json(); })
        .catch(function () { drawer.updateBadge(); })
        .then(function (data) { if (data) drawer.paint(data['dl-cart-drawer'], openAfter); });
    },
    /* Paint the drawer from rendered section HTML. The add and the quantity update ask Shopify for the
       section in the SAME call (the `sections` parameter), so the drawer no longer waits on a second
       request (2026-10-16: tap to drawer measured 0.92, 0.94, 2.51 s on live before this). */
    paint: function (html, openAfter) {
      if (!html || !root) { drawer.updateBadge(); return; }
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('#dl-cart-root');
      if (!fresh) { drawer.updateBadge(); return; }
      root.innerHTML = fresh.innerHTML;
      root.classList.remove('is-pending');
      var cnt = fresh.getAttribute('data-count');
      if (cnt !== null) root.setAttribute('data-count', cnt);
      if (openAfter || root.classList.contains('is-open')) {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        root.querySelector('.dlcd-overlay').hidden = false;
        root.querySelector('.dlcd').hidden = false;
        root.classList.add('is-open');
        document.documentElement.classList.add('dlcd-lock');
        if (root.contains(document.activeElement) === false) {
          var xx = root.querySelector('.dlcd-x');
          if (xx) xx.focus();
        }
      }
      drawer.updateBadge(cnt === null ? undefined : parseInt(cnt, 10));
      /* With the automatic box off, leftover gift lines are cleared once on page load only, so a
         normal add or quantity change costs no extra cart read. */
      if (root.getAttribute('data-gift-enabled') !== 'false') drawer.reconcileGift();
    },
    setBadge: function (n) {
      document.querySelectorAll('.cart-count').forEach(function (b) {
        b.textContent = n;
        b.style.display = n > 0 ? '' : 'none';
      });
      document.querySelectorAll('.cart-link').forEach(function (a) {
        a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      });
    },
    updateBadge: function (known) {
      if (typeof known === 'number' && !isNaN(known)) { drawer.setBadge(known); return; }
      fetch('/cart.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (c) {
        drawer.setBadge(c.item_count);
      }).catch(function () {});
    },
    /* Open on the tap with an "adding" row, before Shopify answers. */
    showAdding: function (info) {
      if (!root) return;
      root.classList.add('is-pending');
      var im = root.querySelector('[data-pend-img]');
      if (im) im.style.backgroundImage = (info && info.img) ? 'url("' + info.img + '")' : '';
      var tt = root.querySelector('[data-pend-title]');
      if (tt && info && info.title) tt.textContent = 'Adding ' + info.title + '...';
      var body = root.querySelector('.dlcd-body');
      if (body) body.scrollTop = 0;
      drawer.open();
    },
    add: function (body, info) {
      drawer.showAdding(info);
      if (body && typeof body.append === 'function') {
        body.append('sections', 'dl-cart-drawer');
        body.append('sections_url', window.location.pathname);
      }
      return fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: body
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function (data) {
        if (data && data.sections && data.sections['dl-cart-drawer']) return drawer.paint(data.sections['dl-cart-drawer'], true);
        return drawer.refresh(true);
      }).catch(function (err) {
        /* the add failed: take the adding row away and close, the caller shows the reason */
        if (root) root.classList.remove('is-pending');
        drawer.close();
        throw err;
      });
    },
    /* Quantity changes go through ONE queue, addressed by line item KEY (2026-09-17 phone audit).
       Two things were wrong before. A `busy` flag DROPPED any tap that landed while a request was
       in flight, and on a phone that chain (change, re-render, gift reconcile, re-render) runs for
       a second or more, so a second tap on minus did nothing: measured 3 kits, two quick taps,
       landed on 2. And a change addressed by line INDEX hits the wrong row once Shopify splits or
       removes the gift line, which is how a cart emptied itself during the audit.
       Now: the newest intent always wins, taps coalesce into one request, nothing is discarded. */
    pending: {},
    inFlight: false,
    flushTimer: null,
    setQty: function (key, qty) {
      if (!key) return;
      drawer.pending[key] = Math.max(0, qty);
      clearTimeout(drawer.flushTimer);
      drawer.flushTimer = setTimeout(drawer.flush, 260);
    },
    flush: function () {
      if (drawer.inFlight) { clearTimeout(drawer.flushTimer); drawer.flushTimer = setTimeout(drawer.flush, 160); return; }
      var updates = drawer.pending;
      if (!Object.keys(updates).length) return;
      drawer.pending = {};
      drawer.inFlight = true;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates, sections: 'dl-cart-drawer', sections_url: window.location.pathname }) })
        .then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); return r.json(); })
        .catch(function (err) { console.warn('cart update failed', err); return null; })
        .then(function (data) {
          drawer.inFlight = false;
          /* A tap that arrived mid-request is still queued: send it before re-rendering, so the
             screen is only ever redrawn from the settled cart. */
          if (Object.keys(drawer.pending).length) { clearTimeout(drawer.flushTimer); return drawer.flush(); }
          if (data && data.sections && data.sections['dl-cart-drawer']) return drawer.paint(data.sections['dl-cart-drawer'], false);
          return drawer.refresh(false);
        });
    },
    /* Kept so any older markup that addresses a line by index still works. */
    change: function (line, qty) {
      var item = document.querySelector('.dlcd-item[data-line="' + line + '"]');
      var key = item && item.getAttribute('data-key');
      if (key) { drawer.setQty(key, qty); return Promise.resolve(); }
      var fd = new FormData();
      fd.append('line', line); fd.append('quantity', qty);
      return fetch(routes.cart_change_url || '/cart/change.js', { method: 'POST', body: fd })
        .then(function () { return drawer.refresh(false); });
    },
    /* Free surprise box: one per Starter Kit in the cart, added and kept in step automatically.
       Ids come from the cart drawer section settings so they can be changed in the editor. */
    giftBusy: false,
    reconcileGift: function () {
      var r = document.getElementById('dl-cart-root');
      if (!r) return Promise.resolve();
      /* Gift off (since 7 Oct 2026): clear any gift line left in a cart from before, so no one pays
         for a box that used to be free. */
      if (r.getAttribute('data-gift-enabled') === 'false') {
        var ogp = r.getAttribute('data-gift-product');
        if (!ogp || drawer.giftBusy) return Promise.resolve();
        drawer.giftBusy = true;
        return fetch('/cart.js').then(function (x) { if (!x.ok) throw 0; return x.json(); }).then(function (c) {
          var updates = {}, n = 0;
          (c.items || []).forEach(function (it) { if (String(it.product_id) === ogp) { updates[it.key] = 0; n++; } });
          if (!n) return null;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
        }).then(function (res) {
          drawer.giftBusy = false;
          if (res) return drawer.refresh(false);
        }).catch(function () { drawer.giftBusy = false; });
      }
      var gv = r.getAttribute('data-gift-variant'), gp = r.getAttribute('data-gift-product'), kp = r.getAttribute('data-kit-product');
      /* The Duo Kit earns TWO boxes (Mohammed, 2026-09-17), the Starter Kit one. Both numbers come
         from the drawer settings so they can be changed in the editor, and each MUST match its
         Shopify automatic discount or the extra box is charged. */
      var dp = r.getAttribute('data-duo-product');
      var dq = parseInt(r.getAttribute('data-duo-gift-qty'), 10);
      if (isNaN(dq)) dq = 2;
      if (!gv || !gp || !kp || drawer.giftBusy) return Promise.resolve();
      drawer.giftBusy = true;
      return fetch('/cart.js').then(function (x) { if (!x.ok) throw 0; return x.json(); }).then(function (c) {
        var kits = 0, gifts = [];
        (c.items || []).forEach(function (it) {
          if (String(it.product_id) === kp) kits += it.quantity;
          if (dp && dq > 0 && String(it.product_id) === dp) kits += it.quantity * dq;
          if (String(it.product_id) === gp) gifts.push(it);
        });
        /* Lowering the kit quantity makes Shopify SPLIT the gift into two lines: one keeps the
           Buy X Get Y allocation, the other is charged at full price. Reading only the last line
           made the counts look equal and left the paid line in the cart, so every gift line is
           reconciled here: the first carries the kit count, the rest go to zero. */
        var have = 0, charged = false;
        gifts.forEach(function (g) { have += g.quantity; if (g.final_line_price > 0) charged = true; });
        /* Two gift lines is LEGITIMATE when two discounts are in play: a Starter Kit and a Duo Kit
           together earn 1 + 2 boxes and Shopify allocates each discount to its own line, both free.
           The defect to catch is a gift line that is being CHARGED, so test that directly rather
           than using the line count as a proxy, which fired on the healthy case too. */
        if (kits === have && !charged) return null;
        if (gifts.length === 0) {
          if (kits === 0) return null;
          var fd = new FormData();
          fd.append('id', gv); fd.append('quantity', kits);
          return fetch('/cart/add.js', { method: 'POST', body: fd });
        }
        var updates = {};
        gifts.forEach(function (g, i) { updates[g.key] = (i === 0 ? kits : 0); });
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
      }).then(function (res) {
        drawer.giftBusy = false;
        if (res) return drawer.refresh(false);
      }).catch(function () { drawer.giftBusy = false; });
    }
  };
  window.dlCartDrawer = drawer;
  if (document.readyState !== 'loading') drawer.reconcileGift();
  else document.addEventListener('DOMContentLoaded', function () { drawer.reconcileGift(); });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-dlcd-close]')) { e.preventDefault(); drawer.close(); var href = t.closest('a'); if (href && href.getAttribute('href')) window.location.href = href.getAttribute('href'); return; }
    var cartLink = t.closest('.cart-link');
    if (cartLink && root) { e.preventDefault(); drawer.refresh(true); return; }
    var qbtn = t.closest('[data-dlcd-qty]');
    if (qbtn) {
      var item = qbtn.closest('.dlcd-item');
      var span = item.querySelector('.dlcd-qty span');
      /* The number on screen already carries every earlier tap, so three fast taps move three
         steps. The screen updates on the tap itself, the request follows once the taps stop. */
      var next = Math.max(0, parseInt(span.textContent, 10) + parseInt(qbtn.getAttribute('data-dlcd-qty'), 10));
      span.textContent = next;
      item.classList.toggle('is-going', next === 0);
      drawer.setQty(item.getAttribute('data-key'), next);
      return;
    }
    var rm = t.closest('[data-dlcd-remove]');
    if (rm) { var ri = rm.closest('.dlcd-item'); ri.classList.add('is-going'); drawer.setQty(ri.getAttribute('data-key'), 0); return; }
    var up = t.closest('[data-dlcd-upsell]');
    if (up) {
      var upLabel = up.textContent;
      up.disabled = true; up.textContent = '...';
      var fd = new FormData(); fd.append('id', up.getAttribute('data-dlcd-upsell')); fd.append('quantity', 1);
      drawer.add(fd).catch(function (err) {
        up.disabled = false; up.textContent = upLabel;
        alert((err && err.description) || 'Could not add to cart.');
      });
      return;
    }
    var ajaxAdd = t.closest('.dl-ajax-add');
    if (ajaxAdd) {
      e.preventDefault();
      ajaxAdd.classList.add('is-busy');
      var fd2 = new FormData(); fd2.append('id', ajaxAdd.getAttribute('data-variant')); fd2.append('quantity', 1);
      drawer.add(fd2).then(function () { ajaxAdd.classList.remove('is-busy'); }).catch(function (err) {
        ajaxAdd.classList.remove('is-busy');
        alert((err && err.description) || 'Could not add to cart.');
      });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { drawer.close(); closeSearch(); }
  });

  /* What the "adding" row shows while Shopify adds: the chosen pack, else the product name. */
  function addInfo(form) {
    var info = {};
    var tier = document.querySelector('.dl-tier input:checked');
    var lab = tier && tier.closest('.dl-tier');
    var timg = lab && lab.querySelector('.dl-tier__img img');
    var ttop = lab && lab.querySelector('.dl-tier__top');
    var gimg = document.querySelector('.pdp-gallery img');
    var h1 = document.querySelector('.pdp-info h1');
    info.img = (timg && (timg.currentSrc || timg.src)) || (gimg && (gimg.currentSrc || gimg.src)) || '';
    info.title = (ttop && ttop.textContent.trim()) || (h1 && h1.textContent.split(' - ')[0].trim()) || '';
    return info;
  }

  /* delegated AJAX add-to-cart for every product form.
     The tap is handled on click, so the browser never fires a native submit: Shopify counts a cart add
     once for the submit event and again for the AJAX request, which doubled add_to_cart in GA4, Google Ads
     and Meta (found 16 Oct 2026, same fix as ANG 15 Oct). Submit stays as the fallback for the Enter key,
     listened in the capture phase so it cancels before Shopify's own form listener looks (Shopify skips a
     send that is already cancelled). One add per form at a time: a second tap while the first is in flight
     is ignored. */
  function isAddForm(form) {
    return form && (form.getAttribute('action') || '').match(/\/cart\/add/) && !form.hasAttribute('data-no-ajax');
  }
  function addForm(form) {
    if (form.__dlBusy) return;
    form.__dlBusy = true;
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    var done = function () { form.__dlBusy = false; if (btn) { btn.disabled = false; btn.textContent = label; } };
    drawer.add(new FormData(form), addInfo(form)).then(done).catch(function (err) {
      done();
      alert((err && err.description) || 'Could not add to cart.');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[type=submit], input[type=submit]');
    if (!b) return;
    var form = b.form || b.closest('form');
    if (!isAddForm(form)) return;
    e.preventDefault();
    addForm(form);
  });
  document.addEventListener('submit', function (e) {
    if (!isAddForm(e.target)) return;
    e.preventDefault();
    addForm(e.target);
  }, true);

  /* page load keeps the live /cart.js read: a cached page could carry an old count */
  drawer.updateBadge();

  /* ---------------- predictive search ---------------- */
  var searchModal = document.getElementById('dl-search-modal');
  function openSearch() {
    if (!searchModal) { window.location.href = routes.search_url || '/search'; return; }
    searchModal.hidden = false;
    document.documentElement.classList.add('dlcd-lock');
    var inp = searchModal.querySelector('input[type=search]');
    setTimeout(function () { inp.focus(); }, 40);
  }
  function closeSearch() {
    if (!searchModal || searchModal.hidden) return;
    searchModal.hidden = true;
    document.documentElement.classList.remove('dlcd-lock');
  }
  window.dlOpenSearch = openSearch;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dl-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-dl-search-close]')) { e.preventDefault(); closeSearch(); }
    if (searchModal && !searchModal.hidden && e.target === searchModal) closeSearch();
  });
  if (searchModal) {
    var input = searchModal.querySelector('input[type=search]');
    var results = searchModal.querySelector('.dls-results');
    var timer;
    var seq = 0;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var mySeq = ++seq;
        var url = (routes.predictive_search_url || '/search/suggest') +
          '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=hide';
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          if (mySeq !== seq) return;
          var res = d.resources.results;
          var html = '';
          if (res.queries && res.queries.length) {
            html += '<div class="dls-queries">' + res.queries.map(function (x) {
              return '<a href="' + (routes.search_url || '/search') + '?q=' + encodeURIComponent(x.text) + '">' + x.styled_text + '</a>';
            }).join('') + '</div>';
          }
          if (res.products && res.products.length) {
            html += '<div class="dls-products">' + res.products.map(function (p) {
              return '<a class="dls-p" href="' + p.url + '">' +
                (p.image ? '<img src="' + p.image + '&width=120" alt="" width="60" height="60" onerror="this.style.display=\'none\'">' : '') +
                '<span class="dls-p-t">' + p.title + '</span>' +
                '<span class="dls-p-pr">' + p.price + '</span></a>';
            }).join('') + '</div>';
          }
          if (!html) html = '<p class="dls-none">Nothing found for "' + q.replace(/</g, '&lt;') + '". Try a flavor name.</p>';
          results.innerHTML = html;
        });
      }, 220);
    });
  }

  /* ---------------- header dropdowns (mobile toggling) ---------------- */
  document.querySelectorAll('.dl-drop > button.dl-drop-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.parentElement;
      var open = li.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.querySelectorAll('.dl-drop').forEach(function (o) {
        if (o !== li) {
          o.classList.remove('is-open');
          var ob = o.querySelector('.dl-drop-btn');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.dl-drop')) document.querySelectorAll('.dl-drop').forEach(function (o) {
      o.classList.remove('is-open');
      var ob = o.querySelector('.dl-drop-btn');
      if (ob) ob.setAttribute('aria-expanded', 'false');
    });
  });
  /* sticky fallback for browsers without :has */
  try { document.querySelector('div:has(> .x)'); } catch (err) {
    var h = document.querySelector('.dl-header');
    if (h && h.closest('.shopify-section')) {
      var sec = h.closest('.shopify-section');
      sec.style.position = 'sticky'; sec.style.top = '0'; sec.style.zIndex = '50';
    }
  }

  /* ---------------- PDP gallery ---------------- */
  var gal = document.querySelector('.pdp-gallery[data-dl-gallery]');
  if (gal) {
    var mainBox = gal.querySelector('.pdpg-main');
    var thumbs = gal.querySelectorAll('.pdpg-thumb');
    /* video thumbs swap the whole main viewer for the product video; image thumbs restore an img */
    thumbs.forEach(function (th) {
      th.addEventListener('click', function () {
        var vid = th.getAttribute('data-video');
        var tpl = vid ? document.getElementById(vid) : null;
        if (tpl && mainBox) {
          mainBox.innerHTML = tpl.innerHTML;
          var v = mainBox.querySelector('video'); if (v) { v.muted = true; v.play && v.play().catch(function () {}); }
        } else if (mainBox) {
          var img = mainBox.querySelector('img');
          if (!img) { mainBox.innerHTML = ''; img = document.createElement('img'); img.width = 600; mainBox.appendChild(img); }
          img.src = th.getAttribute('data-full');
          img.srcset = '';
        }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        th.classList.add('is-active');
      });
    });
    var track = gal.querySelector('.pdpg-track');
    var dots = gal.querySelectorAll('.pdpg-dot');
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () { track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' }); });
      });
    }
  }

  /* ---------------- sticky ATC ---------------- */
  var stickyBar = document.querySelector('.dl-sticky-atc');
  var mainForm = document.querySelector('.pdp-info form[action*="/cart/add"]');
  var stickyBtn = stickyBar ? stickyBar.querySelector('.dl-sticky-btn') : null;
  if (stickyBar && mainForm) {
    var mainBtn = mainForm.querySelector('[type=submit]');
    if ('IntersectionObserver' in window && mainBtn) {
      var io = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && window.scrollY > 300;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('dl-sticky-open', show);
      }, { threshold: 0 });
      io.observe(mainBtn);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var sbtn = this;
      var sLabel = sbtn.textContent;
      sbtn.disabled = true; sbtn.textContent = 'Adding...';
      var fd = new FormData(mainForm);
      drawer.add(fd, addInfo(mainForm)).then(function () {
        sbtn.disabled = false; sbtn.textContent = sLabel;
      }).catch(function (err) {
        sbtn.disabled = false; sbtn.textContent = sLabel;
        alert((err && err.description) || 'Could not add to cart.');
      });
    });
  }
})();
